import { render } from "./FollowUpDashboard.vue?vue&type=template&id=e3d4312a&scoped=true"
import script from "./FollowUpDashboard.vue?vue&type=script&lang=js"
export * from "./FollowUpDashboard.vue?vue&type=script&lang=js"

import "./FollowUpDashboard.vue?vue&type=style&index=0&id=e3d4312a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3d4312a"]])

export default __exports__